import { useTranslation } from 'react-i18next'

import { UpsellBanner } from '@reveni-io/reveni-ui'

import useSmartTrackingRequest from '@/common/hooks/useSmartTrackingRequest/useSmartTrackingRequest'

import { upsellBannerOrientations } from './constants'

const CustomHtmlUpsell = ({ onBackToStandardEditor }) => {
  const { t } = useTranslation()
  const { smartTrackingRequested, requestSmartTracking, requestingSmartTracking } = useSmartTrackingRequest()

  return (
    <UpsellBanner
      orientation={smartTrackingRequested ? upsellBannerOrientations.vertical : upsellBannerOrientations.horizontal}
      title={t('Trae tu propio HTML')}
      description={t(
        'Pega el código que ya usa tu equipo y mantén cada email 100 % fiel a tu marca, mientras Reveni mantiene funcionando las variables y los triggers.'
      )}
      benefits={[t('Tu propio diseño'), t('Variables dinámicas'), t('Todos los idiomas')]}
      primaryAction={{
        label: t('Mejorar a Smart Tracking'),
        onClick: requestSmartTracking,
        loading: requestingSmartTracking,
      }}
      secondaryAction={{ label: t('Volver al editor estándar'), onClick: onBackToStandardEditor }}
      isRequested={smartTrackingRequested}
      requestedTitle={t('Smart Tracking solicitado')}
      requestedMessage={t('Nuestro equipo se pondrá en contacto contigo en breve para activarlo.')}
    />
  )
}

export default CustomHtmlUpsell
